import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'
import { updateCalendar } from '../actions/calendars'

class CalendarsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editId: null, // Track which calendar is being edited
      newName: '', // Track new name input
    }

  }

  goTo(id, e) {
    e.stopPropagation();
    history.push(`/calendars/${id}`)
  }

  startEditing(id, currentName) {
    // Start editing by setting the editId and initial name
    this.setState({ editId: id, newName: currentName })
  }

  handleNameChange(e) {
    this.setState({ newName: e.target.value }) // Update name as user types
  }

  saveName(id) {
    // Call the update API with the new name
    this.props.updateCalendar(id, { Name: this.state.newName })
      .then(() => {
        // Reset the edit state and refresh the list
        this.setState({ editId: null, newName: '' })
        this.props.refreshCalendars() // Assuming a prop function to refresh the list
      })
      .catch(error => {
        // Handle error if the fetchMachine request fails
        console.error('Error updating calendar name:', error);
      });
  }

  render() {
    return (
      <div className="calendars-list">
        <div className="list-group">
          {this.props.calendars.map(calendar => (
            <div
              key={calendar._id}
              className={`list-group-item calendar-card d-flex justify-content-between align-items-center`}
              onClick={e => this.goTo(calendar._id, e)}
            >
              <div style={{ flex: 1 }}>
    {this.state.editId === calendar._id ? (
                  <input
                    className="calendar-name-input"
                    type="text"
                    value={this.state.newName}
                    onClick={(e) => e.stopPropagation()}
                    onChange={e => this.handleNameChange(e)}
                  />
                ) : (
                  (() => {
                    const dates = (calendar.PriceCalendar || [])
                      .map(pc => new Date(pc.date))
                      .filter(d => !isNaN(d))
                      .sort((a, b) => a - b)

                    const startDate = dates.length
                      ? dates[0].toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })
                      : '—'
                    const endDate = dates.length
                      ? dates[dates.length - 1].toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })
                      : '—'

                    const entriesCount = (calendar.PriceCalendar || []).length

                    const priceValues = (calendar.PriceCalendar || []).reduce((acc, pc) => {
                      if (pc.prices && pc.prices.length) {
                        pc.prices.forEach(p => { if (p && typeof p.price === 'number') acc.push(p.price) })
                      }
                      return acc
                    }, [])

                    const minPrice = priceValues.length ? Math.min(...priceValues) : null
                    const maxPrice = priceValues.length ? Math.max(...priceValues) : null
                    const avgPrice = priceValues.length ? (priceValues.reduce((s, v) => s + v, 0) / priceValues.length) : null
                    const fmt = v => v === null ? '—' : v.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })

                    return (
                      <>
                        <div className="calendar-name mb-1">{calendar.Name}</div>
                        <div className="calendar-meta small text-muted">{(new Date(calendar.TimeStamp)).toLocaleDateString('es-ES', {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}</div>

                        <div className="calendar-summary mt-2 d-flex align-items-center" style={{ gap: '10px', flexWrap: 'wrap' }}>
                          <span className="badge badge-light">Días: {entriesCount}</span>
                          <span className="text-muted">Rango: {startDate} — {endDate}</span>
                          <span className="price-summary ml-2">{`Min ${fmt(minPrice)} · Avg ${fmt(avgPrice)} · Max ${fmt(maxPrice)}`}</span>
                        </div>
                      </>
                    )
                  })()
                )} 
              </div>

              <div style={{ display: 'flex', gap: '8px', marginLeft: '12px' }}>
                {this.state.editId === calendar._id ? (
                  <button type="button" className="btn bg-warning text-dark" onClick={(e) => { e.stopPropagation(); this.saveName(calendar._id); }}>
                    Guardar Nombre
                  </button>
                ) : (
                  <button type="button" className="btn bg-info text-white" onClick={(e) => { e.stopPropagation(); this.startEditing(calendar._id, calendar.Name); }}>
                    Editar Nombre
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  updateCalendar: (id, data) => dispatch(updateCalendar(id, data)),
});

export default connect(null, mapDispatchToProps)(CalendarsList);


